export const TiptapMenubar = (props: any) => (
   <div
      // On phones the buttons stay on one horizontally scrollable row
      // instead of wrapping into a stack that eats the viewport.
      className="sticky top-0 z-[1] flex overflow-x-auto rounded-md border border-gray-300 bg-gray-50 p-1 max-md:flex-nowrap md:flex-wrap"
      {...props}
   >
      {props.children}
   </div>
);
